export interface SupportCitation {
  referenceId: string;
  documentId: string;
  title: string;
  blobName?: string | null;
  sourceUrl?: string | null;
  section?: string | null;
  pageNumber?: number | null;
  sourceType?: string | null;
}

/**
 * Short-lived, read-only playback address issued for a private support video.
 */
export interface SupportVideoPlayback {
  url: string;
  expiresOnUtc: string;
}

/**
 * Source type marking a citation whose blob is a private training video that
 * must be streamed, not downloaded. Citations persisted before private video
 * support existed have no sourceType and fall back to the document behaviour.
 */
export const PRIVATE_VIDEO_SOURCE_TYPE = 'support-video-private';

/**
 * Returns whether a citation should open in the video player.
 */
export function isPrivateVideoCitation(citation: SupportCitation): boolean {
  return (
    citation.sourceType === PRIVATE_VIDEO_SOURCE_TYPE &&
    typeof citation.blobName === 'string' &&
    citation.blobName.length > 0
  );
}

export function normalizeSupportCitations(
  citationJson: unknown,
  existingCitations: unknown
): SupportCitation[] {
  let citations = existingCitations;
  if (typeof citationJson === 'string' && citationJson.length > 0) {
    try {
      citations = JSON.parse(citationJson);
    } catch {
      return [];
    }
  }

  if (!Array.isArray(citations)) {
    return [];
  }

  return citations.filter(
    (citation): citation is SupportCitation =>
      citation != null &&
      typeof citation === 'object' &&
      typeof citation.referenceId === 'string' &&
      typeof citation.documentId === 'string' &&
      typeof citation.title === 'string' &&
      (typeof citation.blobName === 'string' ||
        typeof citation.sourceUrl === 'string')
  );
}
